module.exports = __webpack_public_path__ + "static/img/flcp.cd9075b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flcp.png
// module id = L9FH
// module chunks = 101